// extracted by mini-css-extract-plugin
export default {"customTab":"RequestJobPostingTabs_customTab__1B-C8"};